export const EXTENSION_OVERLAY_REMOVAL_LIST_FF =
	'confluence.frontend.extension-overlay-removal-list';
export const OPEN_MACRO_LINKS_IN_NEW_TAB_ALLOWLIST_FF =
	'confluence.frontend.open-macro-links-in-new-tab-allowlist';
